import React from 'react'
import AD from 'react-google-publisher-tag'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import { Helmet } from 'react-helmet'
import share from '~/tools/share'
import {includes, get} from 'lodash'
import {format} from 'date-fns'
import './styles.css'

class PhotoGallery extends React.Component {
	constructor(){
		super()
		this.state={
		 	currentImage: 0,
		 	clickNext: false,
		 	clickPrev: false,
		 	fullScreenMode: false,
		 	adBreak: 0,
		 	closeAd: false
		}
		this.setCurrentImage = this.setCurrentImage.bind(this)
		this.clickPrev = this.clickPrev.bind(this)
		this.clickNext = this.clickNext.bind(this)
		this.slideImage = this.slideImage.bind(this)
		this.toggleFullScreen = this.toggleFullScreen.bind(this)
		this.toggleAd = this.toggleAd.bind(this)
	}

	componentDidMount(){
		this.smallCarousel = document.querySelector('.small-photogallery-carousel .slick-track')
		setTimeout(() => { window.dispatchEvent(new Event('resize')) }, 0)
		window.document.addEventListener('keyup', (e) => {
			if(e.keyCode === 27) {
				if(this.state.fullScreenMode){
					this.setState({
						fullScreenMode: false
					})
				}
			}
			if(e.keyCode === 37){
				this.clickPrev()
			}
			if(e.keyCode === 39){
				this.clickNext()
			}
		})
	}


	componentDidUpdate(prevProps, prevState){
		if (this.state.clickNext && (this.state.currentImage % 5 === 0)){
			const slideCount = this.smallSlider.innerSlider.state.slideCount
			let activeSlides = slideCount - this.state.currentImage 
			let GoTo = (activeSlides < 5) ? (slideCount - activeSlides) : this.state.currentImage
			Promise.resolve(this.smallSlider.slickGoTo(GoTo)).then( ()=>{
				this.slideImage()
					return;
			})
		}

		if (this.state.clickPrev && (this.state.currentImage + 1 === this.smallSlider.innerSlider.state.slideCount)) {
			let activeSlides = (this.state.currentImage + 1 > 5) ? (this.smallSlider.innerSlider.state.slideCount - (this.smallSlider.innerSlider.state.slideCount%5)) : 0
			Promise.resolve(this.smallSlider.slickGoTo(activeSlides)).then(() => {
				this.slideImage()
				return;
			})
		}

		if (this.state.clickPrev && !(this.state.currentImage === 0) && this.smallCarousel.children[prevState.currentImage].previousSibling !== null &&  !this.smallCarousel.children[prevState.currentImage].previousSibling.classList.contains('slick-active') ){
			Promise.resolve(this.smallSlider.slickPrev()).then( ()=>{
				this.slideImage()
				return;
			})
		}
		this.slideImage()
	}

	clickNext(){
		this.bigSlider.slickNext()
		if(!(this.state.currentImage + 1 === this.smallSlider.innerSlider.state.slideCount) ) {
			this.setState({
				currentImage: this.state.currentImage + 1,
				clickNext: true,
				clickPrev: false
			})
		} else {
			this.setState({
				currentImage: 0,
				clickNext: true,
				clickPrev: false
			})
		}
		if(this.state.fullScreenMode){
			this.adIntervalCheck()
		}
	}

	adIntervalCheck(){
		this.setState({
			adBreak: this.state.adBreak + 1,
			closeAd: false
		})
	}

	get helmet() {
		const { gist = {}, seo = {} } = this.props.data.contentData[0]

		return (
			<Helmet>
				<title>{`${seo.title || gist.title} | ${window.settings.site}`}</title>
				<meta name="description" content={seo.description || gist.description} />
				{seo.keywords &&
					<meta name="keywords" content={seo.keywords.join(',')} />
				}
				<meta property="og:type" content="image.gallery" />
				<meta property="og:title" content={seo.title || gist.title} />
				<meta property="og:description" content={seo.description || gist.description} />
				<meta property="og:image" content={ gist.landscapeImageUrl || get(window.settings, 'images.placeholderCover')} />
			</Helmet>
		)
	}

	renderImage(image){
		const style={
			backgroundImage:  `url(${image})`
		}
		return(
			<figure className="image-container">
				<div className="image" style={style}></div>
			</figure>
		)
	}

	renderSmallSlideImages(image){
		const style={
			backgroundImage:  `url(${image})`
		}
		return(
			<figure className="image-container">
				<div className="image" style={style}></div>
			</figure>
		)
	}

	slideImage(){
		const currentElement = document.querySelector('.slick-current')
		if(currentElement){
			currentElement.classList.remove('slick-current')
		}
		this.smallCarousel.children[this.state.currentImage].classList.add('slick-current')
	}

	setCurrentImage(e){
		const currentElement = document.querySelector('.slick-current')
		const target = e.currentTarget
		if(currentElement){
			currentElement.classList.remove('slick-current')
		}
		this.bigSlider.slickGoTo(parseInt(target.dataset.index, 10))
		this.setState({
			currentImage: parseInt(target.dataset.index, 10)
		})
		target.classList.add('slick-current')
	}

	clickPrev(){
		this.bigSlider.slickPrev()
		if(this.state.currentImage > 0){
			this.setState({
				currentImage: this.state.currentImage - 1,
				clickPrev: true,
				clickNext: false
			})
		} else {
			this.setState({
				currentImage: this.smallSlider.innerSlider.state.slideCount - 1,
				clickPrev: true,
				clickNext: false
			})
		}
		if(this.state.fullScreenMode){
			this.adIntervalCheck()
		}
	}

	toggleFullScreen(){
		this.setState({
			fullScreenMode: !(this.state.fullScreenMode)
		})
	}

	toggleAd(){
		this.setState({
			closeAd: !(this.state.closeAd)
		})
	}

	displayAdContainer(adTag){
		return(
			<div className="ad-container">
				<div className="ad-copy">Advertisement</div>
				<div className="ad">
					<AD path={adTag} dimensions={[[300, 250]]}/>
				</div>	
				<div className="ad-close" onClick={this.toggleAd}>Close</div>
			</div>
		)
	}

	render(){
		const contentData = this.props.data.contentData[0]
		const galleryGist = contentData.gist
		const images = contentData.streamingInfo.photogalleryAssets
    const tags = contentData.tags.map(tag => tag.title)
    const adTag = get(this.props.data, 'metadataMap.adTag')
		
		const PrevButton= ({className}) =>{
      return <button onClick={this.clickPrev} className={className}></button>;
		}
    

    const NextButton=({className}) =>{
      return <button onClick={this.clickNext} className={className}></button>;
    }
		
		const bigCarouselSetting = {
			infinite: true,
			speed: 200,
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow: <PrevButton />,
			nextArrow: <NextButton />,
		}

		const smallCarouselSetting = {
			infinite: false,
			speed: 300,
			slidesToShow: 5,
			slidesToScroll: (images.length > 5) ? 5 : images.length,
			dots: (images.length > 5) ? true : false,
			arrows: (images.length > 5) ? true : false,
			nextArrow: images.length > 5 && <CarouselArrow itemCount={images.length} />,
			prevArrow: images.length > 5 && <CarouselArrow itemCount={images.length} />
		}

		return(
			<div className={`photo-gallery ` +  (this.state.fullScreenMode ? 'full-screen': '')}>
					{this.helmet}
					<div className="photo-gallery-content">
						{!this.state.fullScreenMode && <div className="title-container">
						<div className="title">{galleryGist.title}</div>
							<div className="title-metadata">
								<div className="author-details">
								{contentData.contentDetails.author && <span className="name details"> By {contentData.contentDetails.author.name}</span>}
								{galleryGist.publishDate && <span className="date details"> {format(galleryGist.publishDate, 'MMM D')}</span> }
									<span className="count details">{images.length} Photos</span>
								</div>
								{tags.length > 0 && <div className="tagged"><span className="tag-key">TAGGED:</span> <span className="tag-value">{tags.sort().join()}</span></div>}
							</div>
						</div> }
					<div className="photos-count"> {this.state.currentImage + 1}/{images.length}</div>
						<div className="photogallery-carousel-containers">
							<div className="photogallery-carousels">
								<div className="big-photogallery-carousel">
									<Slider {...bigCarouselSetting} ref={Slider => this.bigSlider = Slider}>
										{images.map((item, i) => (
										<div key={i} onLoad={() => window.dispatchEvent(new Event('resize'))}>{this.renderImage(item.secureUrl)}</div>
										) ) }        					
									</Slider>
									<div className="full-screen-button" aria-label="Open Full Screen" onClick={this.toggleFullScreen}></div>
								</div>
								<div className={`small-photogallery-carousel` + (images.length <=5 ? ' dont-transform': '' )}>
									<Slider {...smallCarouselSetting} ref={Slider => this.smallSlider = Slider}>
										{images.map((item, i) => (
										<div className={(i === 0) && 'slick-current site-border-color'} key={i} onClick={(e) => this.setCurrentImage(e)} >{this.renderImage(item.secureUrl)}</div>
										) ) }        					
									</Slider>
								</div> 
							</div>	
							{adTag && <div className="photo-gallery-ad-container">
								<div className="photo-gallery-ad">
									<AD path={adTag} dimensions={[[300, 250]]}/>
								</div>
							</div>}
					</div>
					{(this.state.adBreak % 3 === 0 && this.state.adBreak !== 0 && !this.state.closeAd && this.state.fullScreenMode && window.google && adTag) && this.displayAdContainer(adTag)}
				</div>
				
				<div className="photo-gallery-share">
					<div className="share-options">
						<div className="copy"> Share this Gallery</div>
						<div className="sharing">
							<i
                className="ion-social-facebook"
                onClick={share.facebook.bind(this, window.location.href)}
              />
              <i
                className="ion-social-twitter"
								onClick={share.twitter.bind(this, window.location.href, galleryGist.title)}
              />
              <i
                className="ion-ios-email-outline"
                onClick={share.email.bind(this, window.location.href)}
              />
						</div>
					</div>
					<div className="next-gallery"></div>
				</div>
			</div>
		)
	}
}

class CarouselArrow extends React.Component {
  constructor(props) {
    super(props)

    this.style = {}
    let orientation = includes(props.className, 'slick-prev') ? 'left' : 'right'
    let position = (props.itemCount / 5) * 30

    this.style[orientation] = `calc(50% - ${ position }px)`
  }

  render() {
    return(
			<button
       	style={ this.style }
        className={ this.props.className }
        onClick={this.props.onClick}>
      </button>
		)
  }
}



export default PhotoGallery
